
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_388_439)","stroke":"#F19090","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M5.571 3H4.286c-.341 0-.668.145-.91.403A1.425 1.425 0 003 4.375v8.25c0 .365.135.714.377.972.24.258.568.403.909.403h6.428c.341 0 .668-.145.91-.403.24-.258.376-.607.376-.972v-8.25c0-.365-.136-.714-.377-.972A1.245 1.245 0 0010.714 3H9.43"}}),_c('path',{attrs:{"d":"M6 3.5c0-.398.14-.78.39-1.06.25-.282.59-.44.943-.44h1.334c.353 0 .692.158.942.44.25.28.391.662.391 1.06s-.14.78-.39 1.06c-.25.282-.59.44-.943.44H7.333c-.353 0-.692-.158-.942-.44A1.6 1.6 0 016 3.5zM6 8h.007M8.666 8H10M6 10.667h.007M8.666 10.667H10"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_388_439"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    